
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.55 1.35a.75.75 0 00-.75.75v7.5c0 .415.336.75.75.75h7.5a.75.75 0 00.75-.75 8.25 8.25 0 00-8.25-8.25zm-3.627 2.054a9.524 9.524 0 109.524 9.524.75.75 0 00-.75-.75h-8.024V4.154a.75.75 0 00-.75-.75z"}})])
          )
        }
      }
    